import { useState } from 'react';

interface Ripple {
  id: number;
  x: number;
  y: number;
}

export const useRippleEffect = () => {
  const [ripples, setRipples] = useState<Ripple[]>([]);
  const [rippleId, setRippleId] = useState(0);

  const createRipple = (e: React.MouseEvent<HTMLElement>) => {
    // Only create ripples when clicking on the background, not on interactive elements
    const target = e.target as HTMLElement;
    if (target.closest('button, .product-card, .solution-card, a, input, [role="button"]')) {
      return;
    }

    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const newRipple: Ripple = {
      id: rippleId,
      x,
      y,
    };

    setRipples(prev => [...prev, newRipple]);
    setRippleId(prev => prev + 1);

    setTimeout(() => {
      setRipples(prev => prev.filter(ripple => ripple.id !== newRipple.id));
    }, 2000);
  };

  return { ripples, createRipple };
};